module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-4-b001112225dadf4fb54a45325f021a0f.jpg";